<div class="navigation-menu">
  <!-- Dashboard - Item sem categoria (sempre no topo) -->
  <div class="dashboard-section mb-3">
    <div *ngFor="let item of getMenuItemsWithoutCategory()" class="space-y-0.5">
      <a
        [routerLink]="isComingSoonFeature(item.route) ? '' : item.route"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: true }"
        class="menu-item dashboard-item flex items-center py-2.5 px-3 rounded-lg transition-all duration-200 relative group font-medium"
        [class.new-item]="item.isNew"
        [class.updated-item]="item.isUpdated && !item.isNew"
        [class.coming-soon]="isComingSoonFeature(item.route)"
        [class.active-dashboard]="isMenuItemActive(item)"
        [attr.data-route]="item.route"
        [attr.title]="item.description || item.title"
        (click)="onItemClick(item)"
      >
        <!-- Item Icon -->
        <app-icon
          [name]="item.icon"
          [color]="'gray'"
          [size]="18"
          class="menu-icon dashboard-icon"
        ></app-icon>

        <!-- Item Text (only when expanded) -->
        <span
          *ngIf="isMenuExpanded"
          class="menu-text ml-3 text-sm flex-1 flex items-center justify-between font-semibold"
        >
          <span class="flex items-center">
            {{ item.title }}
          </span>

          <div class="flex items-center space-x-1">
            <!-- New Badge -->
            <span
              *ngIf="item.isNew"
              class="status-badge new-status text-xs px-1 py-0.5 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-full font-bold shadow-lg animate-pulse"
              title="Funcionalidade nova!"
              >N</span
            >

            <!-- Updated Badge -->
            <span
              *ngIf="item.isUpdated && !item.isNew"
              class="status-badge updated-status text-xs px-1 py-0.5 bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-full font-semibold"
              title="Atualizado"
              >A</span
            >
          </div>
        </span>

        <!-- Badge for collapsed menu -->
        <div
          *ngIf="!isMenuExpanded && (item.isNew || item.isUpdated)"
          class="absolute -top-1 -right-1"
        >
          <span class="flex h-3 w-3">
            <span
              class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"
              *ngIf="item.isNew"
            ></span>
            <span
              class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"
              *ngIf="item.isUpdated && !item.isNew"
            ></span>
            <span
              class="relative inline-flex rounded-full h-3 w-3"
              [class.bg-green-500]="item.isNew"
              [class.bg-blue-500]="item.isUpdated && !item.isNew"
            ></span>
          </span>
        </div>
      </a>
    </div>
  </div>

  <!-- Loop through categories -->
  <div
    *ngFor="let category of getVisibleCategories(); let isLast = last"
    class="category-section"
    [attr.data-category]="category.id"
  >
    <!-- Category Header -->
    <div *ngIf="isMenuExpanded" class="category-header px-3 py-2">
      <button
        (click)="toggleCategory(category.id)"
        class="flex items-center w-full text-xs font-bold text-gray-600 uppercase tracking-wider border-b border-gray-200 pb-1 hover:text-gray-800 transition-colors cursor-pointer"
        [title]="
          isCategoryExpanded(category.id)
            ? 'Retrair categoria'
            : 'Expandir categoria'
        "
      >
        {{ category.name }}

        <!-- Toggle Icon -->
        <app-icon
          [name]="
            isCategoryExpanded(category.id)
              ? 'keyboard_arrow_up'
              : 'keyboard_arrow_down'
          "
          [size]="14"
          class="ml-auto text-gray-400 transition-transform"
        ></app-icon>

        <!-- Category item count -->
        <span
          class="ml-1 text-xs bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded-full"
        >
          {{ getMenuItemsByCategory(category.id).length }}
        </span>
      </button>
    </div>

    <!-- Category Icon Only (when menu is collapsed) -->
    <div
      *ngIf="!isMenuExpanded"
      class="collapsed-category flex justify-center py-1.5"
    >
      <app-icon
        [name]="category.icon"
        color="gray"
        [size]="14"
        [attr.title]="category.name"
      ></app-icon>
    </div>

    <!-- Menu Items - só mostra se categoria estiver expandida ou menu colapsado -->
    <div
      *ngIf="!isMenuExpanded || isCategoryExpanded(category.id)"
      class="menu-items space-y-0.5"
      [@slideInOut]="
        !isMenuExpanded || isCategoryExpanded(category.id) ? 'in' : 'out'
      "
    >
      <a
        *ngFor="let item of getMenuItemsByCategory(category.id)"
        [routerLink]="isComingSoonFeature(item.route) ? '' : item.route"
        routerLinkActive="active-link"
        class="menu-item flex items-center py-1.5 px-3 rounded-md transition-colors relative group"
        [class.new-item]="item.isNew"
        [class.updated-item]="item.isUpdated && !item.isNew"
        [class.coming-soon]="isComingSoonFeature(item.route)"
        [attr.data-route]="item.route"
        [attr.title]="item.description || item.title"
        (click)="onItemClick(item)"
      >
        <!-- Tooltip for new/updated items -->
        <div
          *ngIf="
            (item.isNew || item.isUpdated) && item.description && isMenuExpanded
          "
          class="absolute left-full ml-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-50 whitespace-nowrap"
        >
          {{ item.description }}
          <div
            class="absolute top-1/2 left-0 transform -translate-y-1/2 -translate-x-1 w-2 h-2 bg-gray-900 rotate-45"
          ></div>
        </div>
        <!-- Item Icon -->
        <app-icon
          [name]="item.icon"
          [color]="'gray'"
          [size]="16"
          class="menu-icon"
        ></app-icon>

        <!-- Item Text (only when expanded) -->
        <span
          *ngIf="isMenuExpanded"
          class="menu-text ml-2 text-xs flex-1 flex items-center justify-between"
        >
          <span class="flex items-center">
            {{ item.title }}
          </span>

          <div class="flex items-center space-x-1">
            <!-- New Badge - Destaque especial -->
            <span
              *ngIf="item.isNew"
              class="status-badge new-status text-xs px-1 py-0.5 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-full font-bold shadow-lg animate-pulse"
              title="Funcionalidade nova e inovadora!"
              >N</span
            >

            <!-- Updated Badge -->
            <span
              *ngIf="item.isUpdated && !item.isNew"
              class="status-badge updated-status text-xs px-1 py-0.5 bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-full font-semibold"
              title="Funcionalidade atualizada recentemente"
              >A</span
            >

            <!-- Coming Soon Badge -->
            <span
              *ngIf="isComingSoonFeature(item.route)"
              class="status-badge coming-soon-status text-xs px-1 py-0.5 bg-gradient-to-r from-orange-400 to-orange-500 text-white rounded-full font-medium"
              title="Em desenvolvimento - Em breve disponível"
              >B</span
            >
          </div>
        </span>

        <!-- Badge for collapsed menu -->
        <div
          *ngIf="!isMenuExpanded && (item.isNew || item.isUpdated)"
          class="absolute -top-1 -right-1"
        >
          <span class="flex h-3 w-3">
            <span
              class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"
              *ngIf="item.isNew"
            ></span>
            <span
              class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"
              *ngIf="item.isUpdated && !item.isNew"
            ></span>
            <span
              class="relative inline-flex rounded-full h-3 w-3"
              [class.bg-green-500]="item.isNew"
              [class.bg-blue-500]="item.isUpdated && !item.isNew"
            ></span>
          </span>
        </div>
      </a>
    </div>
  </div>

  <!-- Fallback when no menu items are visible -->
  <div
    *ngIf="getVisibleCategories().length === 0"
    class="empty-menu p-4 text-center text-gray-500"
  >
    <app-icon name="info" [size]="24" class="mb-2 mx-auto"></app-icon>
    <p class="text-sm">Sem itens de menu disponíveis para seu perfil.</p>
  </div>
</div>
